export const i18nComponents = {
  table: {
    ALL: 'Select all',
    '-': '(Empty)',
  },
  coming_soon_tag: 'Coming soon',
  notifications_manager: {
    tabs: {
      NEW: 'Add New',
      LIST: 'Notifications',
      EDIT: 'Edit',
    },
    select_asset: 'Select an asset',
    frequency: 'Frequency',
    select_frequency: 'Select frequency',
    frequency_options: {
      DAILY: 'Daily',
      MONDAYS: 'Mondays',
      TUESDAYS: 'Tuesdays',
      WEDNESDAYS: 'Wednesdays',
      THURSDAYS: 'Thursdays',
      FRIDAYS: 'Fridays',
      SATURDAYS: 'Saturdays',
    },
    notification_type: {
      title: 'What do you want to be notified about?',
      alarms: {
        title: 'Alarms',
        models: {
          placeholder: 'Select models',
          emptyOptions: 'No models available for this asset',
          all: 'All models',
        },
        categories: {
          placeholder: 'Select categories',

          all: 'All categories',
        },
      },
      cases: {
        title: 'Cases',
        disciplines: {
          placeholder: 'Select disciplines',
          emptyOptions: 'No disciplines available for this asset',
          all: 'All disciplines',
        },
        updates_on: {
          placeholder: 'Select updates on',
          emptyOptions: 'No updates available for this asset',
          all: 'All updates',
        },
        tooltip: ' This feature is not available yet',
      },
      oil_vibration_analysis: {
        title: 'Oil Vibration Analysis',
      },
      health_score: {
        title: 'Health Score',
        low_limit: {
          text: 'Notify me when the Health score drops below',
        },
      },
      sensor: {
        title: 'Sensor offline',
        tooltip: ' This feature is not available yet',
      },
    },
    save: 'Save notification',
    description: 'Please, enter a short description for this notification',
    notifications_list: {
      toggle: 'Notify me of updates in Cases where I am the owner',
    },
  },
  permissioned_button: {
    unauthorized:
      'Sorry, you are not able to perform this action due to limited permissions. Please contact the system administrator.',
  },
  downloadCSVButton: {
    tooltip: 'Download a CSV file with the list below',
  },
  scallingModels: {
    status: { high: 'High', low: 'Good', medium: 'Medium' },
    statusDetail: {
      HIGH: '(risk 0,75 to 1,00)',
      LOW: '(risk under 0,50)',
      MEDIUM: '(risk 0,50 to 0,75)',
    },
  },
  event_list: {
    id: 'Event ID',
    asset_name: 'Asset',
    classification: 'Classification',
    description: 'Description',
    model: 'Model',
    start_time: 'Time',
    status: 'Status',
    type: 'Type',
    filters: {
      asset: 'Asset',
      copy: 'Copy table items to clipboard',
      export_csv: 'Export table items to CSV file',
      period: 'Period',
      search: 'Search',
      copied_success: 'Copied to clipboard',
    },
  },
  date_filter: {
    reference_date: 'Reference date',
    creation: 'Start',
    closing: 'End',
    period: 'Period',
    alarm: 'Alarm period',
    alarm_period: 'Current Alarm',
    event_period: 'Current Event',
    last_n_days: 'Last {{days}} days',
    last_n_hours: 'Last {{hours}} hours',
    max_period: 'Max period',
    all: 'All',
    custom: 'Custom',
    start_date: 'Start',
    end_date: 'End',
    real_time: 'Real time',
    date: {
      lts: 'MM/DD/YYYY',
      datetime_minute: 'MM/DD/YYYY HH:mm',
      datetime_second: 'DD MMM HH:mm:ss',
      month_year: 'MMM/YYYY',
    },
    invalid_range: 'Interval must be less than {{maxMonthsRange}} months',
  },
  asset_card: {
    alarm: {
      alarm_zero: 'No alarms',
      alarm_one: '{{count}} alarm',
      alarm_other: '{{count}} alarms',
    },
    event: {
      event_zero: 'No events',
      event_one: '{{count}} event',
      event_other: '{{count}} events',
    },
    sensor: {
      delayed: {
        delayed_zero: 'No delayed sensors',
        delayed_one: '{{count}} delayed sensor',
        delayed_other: '{{count}} delayed sensors',
      },
      offline: {
        offline_zero: 'No offline sensors',
        offline_one: '{{count}} offline sensor',
        offline_other: '{{count}} offline sensors',
      },
      active: {
        active_zero: 'No active sensor',
        active_one: '{{count}} active sensor',
        active_other: '{{count}} active sensors',
      },
      no_data: {
        no_data_zero: 'No no data sensors',
        no_data_one: '{{count}} no data sensor',
        no_data_other: '{{count}} no data sensors',
      },
    },
    fallback: {
      alarms: 'Error to load alarms data',
      events: 'Error to load events data',
      sensors: 'Error to load sensors data',
      models: 'Error to load models data',
    },
  },
  breadcrumb: {
    go_back: 'Back',
  },
  footer: {
    my_requests: 'Feedback and Support',
  },
  header: {
    asset_tree: {
      title: 'Asset tree',
      open_editing_mode: 'Open editing mode',
      exit_editing_mode: 'Exit editing mode',
    },
    tab_menu: {
      alarms: 'Alarm',
      events: 'Alarm',
      sensors: 'Sensor',
      vet: 'VET',
      monitoring: 'Monitoring',
      models: 'Model',
      overview: 'Overview',
      users_and_roles: 'Users and Roles',
      access_levels: 'Access Levels',
      notifications: 'Notifications',
      deviations: 'Condition Deviation',
      reports: 'Report',
      health: 'Asset Health',
      cases: 'Cases',
      oil_system: 'Performance',
      flare: 'Flare',
    },
    user_menu: {
      greeting: 'Hello, {{user}}',
      exit: 'Sign out',
      language: {
        'pt-BR': 'Português',
        es: 'Español',
        en: 'English',
      },
      users_and_permissions: 'Users and permissions',
      notifications: 'Notifications',
      sound_alert: 'Sound alert',
      help: 'Help',
    },
  },
  notifications: {
    title: 'Your Alarm Notifications',
    helperText:
      'We will send an alarm notification to the email address you use to log in, at the chosen frequency (always at 7:00).',
    empty: 'No more notifications set. You can ',
    emptyLink: 'add a new notification.',
    item: 'notification',
    columns: {
      email: 'Email',
      whatsapp: 'Whatsapp',
      frequency: 'Frequency',
      model_label: 'Model',
      asset: 'Asset',
      edit: '',
      description: 'Description',
      subjects: 'Notifications',
    },
    alarm_type: {
      model: 'Model',
      category: 'Category',
      all: 'All',
    },
    frequency: {
      daily: 'Daily',
      mondays: 'Mon',
      tuesdays: 'Tue',
      wednesdays: 'Wed',
      thursdays: 'Thu',
      fridays: 'Fri',
      saturdays: 'Sat',
      sunday: 'Sun',
      by_asset: 'By Asset',
    },
    form: {
      title: 'Add new notification',
      labels: {
        email: 'Email',
        whatsapp: 'Whatsapp',
        frequency: 'Frequency',
        model: 'Select a Model',
        asset: 'Select an asset',
        switchOn: 'ON',
        switchOff: 'OFF',
      },
      placeholders: {
        modelWithoutAsset: 'Awaiting asset selection',
        withoutModel: 'No Models available for this asset',
      },
      buttons: {
        add: 'Add',
        save: 'Save',
        edit: 'Edit',
        duplicate: 'Duplicate',
        delete: 'Delete',
      },
    },
  },
  image_uploader: {
    action: {
      select: 'Select an image',
      send: 'Send',
      delete: 'Delete',
    },
    title: 'Image upload',
    tooltip: 'Select an image to enable send button',
  },
  login: {
    email: 'E-mail',
    login_btn: 'Login',
  },
  private_route: {
    confirm: 'OK',
    message: {
      access_denied: {
        title: 'Access denied',
        message: 'You are not allowed to use this feature',
      },
    },
  },
  pump_curve_graph: {
    updated_at: 'Data from {{timestamp}}',
    update_rate: 'Updated every {{interval}} {{unit}}',
    no_timeline_data_for_the_selected_period: 'No timeline data for the selected period',
    legend: {
      rotation: 'Rotation',
      pump_operation: 'Pump operation',
      optimal_range: 'Optimal range',
    },
  },
  sensors_graph: {
    legend: {
      data: 'Data',
      threshold: 'Thresholds',
      risk_area: 'Risk period',
      alarm: 'Alarm + risk period',
    },
    clear_zoom: 'Clear zoom',
    no_value: 'No value',
    message: {
      no_sensors_selected: {
        title: 'No selected sensors',
        message: 'Select at least one item',
      },
      no_data: {
        title: 'No data found',
        message: 'Please, apply other filters or try again later',
      },
      generic_error: {
        title: 'Ops..',
        message: 'Could not load sensors data. Please try again later',
      },
    },
    tabs: {
      sensors: 'Sensors',
      features: 'Features',
    },
  },
  radar_graphic: {
    title: 'Radar view',
    message: {
      no_data: {
        title: 'No data found',
        message: 'Please, apply other filters or try again later',
      },
    },
  },
  line_chart: {
    title: 'Line chart',
    no_data: 'No data available',
    error: 'An error occurred while loading the data, please try again later',
    no_data_for: 'No data for {{name}} in the selected period.',
    try_other: 'Please, try selecting another period or another tag below.',
  },
  risk_score_chart: {
    risk: 'Risk Score',
    unit: 'Risk',
    high_risk: 'High Risk',
  },
  plot_scaling: {
    title: 'Plot view',
    legend: {
      no_alarming: 'No Alarming',
      warning: 'Warning',
      alarming: 'Scaling Alarm',
      upper_limit: 'Upper Limit',
      target_region: 'Target Region',
      lower_limit: 'Lower Limit',
      learned_region: 'Learned Region',
    },
    tooltip: {
      date: 'Date and time',
      itens: 'Grouped Items',
    },
    message: {
      model_version: 'Model version',
      selected_period_is_older:
        'The selected period is older than the model version and will not be fully displayed',
    },
  },
  authorized_users: {
    tabs: {
      authorized_users: 'Authorized Users',
      groups: 'Groups',
    },
    table_headers: {
      name: 'Name',
      email: 'Email',
      roles: 'Roles',
      groups: 'Groups',
      created: 'Created',
      status: 'Status',
    },
    chars_limit: '24 characters limit',
    add_user: 'Add User',
    select_roles: 'Select roles',
    select_value_to_save: 'Select value to save',
    modal: {
      add_user: 'Enter user name',
      name: 'Name',
      enter_name: 'Enter user name',
      email: 'Email',
      users: 'Users',
      enter_email: 'Enter user email',
      roles: 'Roles',
      enter_roles: 'Select user roles',
      required_field: 'This field is required',
    },
    roles_success: 'User roles were successfully edited',
    roles_group_success: 'Group roles were successfully edited',
    group_data_success: 'Group data is successfully edited',
  },
  user_groups: {
    group_name: 'Group name',
    users: 'Users',
    roles: 'Roles',
    status: 'Status',
    placeholder: 'Type or paste user emails',
    add_user_to_group: 'Add users to group',
    delete_user_from_group: 'Delete user from group',
    cancel: 'Cancel',
    yes_delete_user: 'Yes, delete user',
    delete: 'Delete',
    from_group: 'from group',
    new_group: 'New Group',
    add_group: 'Add Group',
    no_users: 'No Users',
  },
  access_levels: {
    table_headers: {
      group: 'Group',
      attribute: 'Attribute',
      values: 'Values',
    },
    select_group: 'Select a group',
    select_attribute: 'Select an attribute',
    select_values: 'Select values',
  },

  notification: {
    title: 'Phone notifications',
    phoneNumber: 'Phone number',
    type: 'Type',
    action: {
      addNew: 'Add new',
      save: 'Save',
    },
    placeholders: {
      phoneNumber: 'Ex: 5521987654321',
      selectAnOption: 'Select an option',
    },
    selectOptions: {
      whatsApp: 'Whatsapp',
      sms: 'SMS',
      whatsAppAndSms: 'Whatsapp + SMS',
    },
    messages: {
      duplicate_attribute_name: 'Duplicate attribute name',
      only_numbers: 'Only numbers',
    },
  },
  ConditionDeviation: {
    item: 'Condition Deviation',
    openAsset: 'Open asset',
    newCd: 'New CD',
    openNewCD: 'Create new Condition Deviation',
    editCD: 'Edit Condition Deviation',
    asset: 'Asset',
    newAsset: 'Select an asset',
    asset_id: 'Asset ID',
    dimension: 'Dimension',
    category: 'Category',
    category_id: 'Category Id',
    detection_method: 'Detection Method',
    deviation_start: 'Deviation start',
    deviation_end: 'Deviation end',
    duration: 'Duration',
    diagnosis: 'Diagnosis',
    detailing: 'Detailing',
    recommended_action: 'Recommended actions',
    actionStatus: 'Action status',
    sap_note: 'Note',
    sapNoteTooltip: 'Note field is required with Action status “Action issued”',
    assetConditionEvaluation: 'Severity',
    condition_evaluation: 'Severity',
    assetStatus: 'Asset status',
    savings: 'Savings',
    savings_required: 'Savings',
    savingsNoteTooltip: 'Savings field is optional and can be filled anytime',
    description: 'Description',
    equipment_class: 'Asset class',
    subunit: 'Subunit',
    maintainable_item: 'Maintainable item',
    failureMode: 'Failure mode',
    failure_mechanism: 'Failure mechanism',
    maintenance_scope: 'Maintenance scope',
    noFillesAttached: 'No files attached',
    alarmsLinked: '{{alarmsCount}} Alarms linked',
    toThisCD: 'to this Condition Deviation',
    addViewAlarms: 'Add/view asset alarms',
    last_updated_by: 'Last updated by',
    attachFile: 'Attach file',
    is_out_of_service: 'Asset can operate?',
    outOfServiceOptions: {
      yes: 'Able to operate',
      no: 'Unable to operate',
    },
    options: {
      action_status: {
        INVESTIGATING: 'Investigating',
        ACTION_ISSUED: 'Action issued',
        CANCELED: 'Cancelled',
        UNDER_EVALUATION: 'Under evaluation',
        COMPLETED: 'Completed',
      },
      dimensions: {
        AUXILIARY_SYSTEM: 'Auxiliary System',
        PROCESS_CONDITION: 'Process Condition',
        DYNAMIC_CONDITION: 'Dynamic Condition',
        OIL_ANALYSIS: 'Oil Analysis',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Low',
        ALARM_CONDITION: 'Medium',
        CRITICAL_CONDITION: 'Very High',
        POTENTIAL_PROBLEM: 'High',
        NOT_MONITORED: 'Not Monitored',
        NOT_OPERATED: 'Not Operated',
        modec: {
          NORMAL_CONDITION: 'Normal Condition',
          ALARM_CONDITION: 'Alarm Condition',
          CRITICAL_CONDITION: 'Critical Condition',
          POTENTIAL_PROBLEM: 'Potential Problem',
          NOT_MONITORED: 'Not Monitored',
          NOT_OPERATED: 'Not Operated',
        },
      },
    },
    confirmChangeAsset:
      'If you change the Asset, the linked alarms will be cleared. Continue anyway?',
    yesContinue: 'Yes, continue',
    save: 'Save',
    cancel: 'Cancel',
    placeholders: {
      assetName: 'Start typing to display options',
      dimension: 'Select dimension',
      selectAnOption: 'Select an option',
      select: 'Select',
      dayHour: 'Pick day and hour',
      diagnosis: 'Enter deviation diagnosis',
      detailing: 'Enter details',
      recommendedActions: 'Enter recomendations',
      sapCode: 'Enter note',
      description: 'A short summary about the saving event',
    },
    messages: {
      toBeRequired: 'This field is required',
      confirmTurnOffCannotOperate:
        'Are you sure you want to TURN OFF status CANNOT OPERATE for this equipment?',
      confirmTurnOnCannotOperate:
        'Are you sure you want to TURN ON status CANNOT OPERATE for this equipment?',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    modalTitles: { new: 'Open New Condition Deviation', edit: 'Condition Deviation' },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'High',
      CRITICAL_CONDITION: 'Very High',
      ALARM_CONDITION: 'Medium',
      NORMAL_CONDITION: 'Low',
    },
  },
  upload: {
    attach_file: 'Attach file',
    infoText:
      'You can only attach one file at a time. Allowed formats: {{acceptFiles}} with a size of up to {{maxFileSize}}Mb',
    noFillesAttached: 'No files attached',
    errorFiles: 'You can only attach one file each time',
    duplicatedFile: 'This file is already attached',
    maxFileSize: 'File size exceeds the limit of {{maxFileSize}}Mb',
    invalidFormat: 'Invalid file format. Allowed formats: {{acceptFiles}}',
    add: {
      title: 'File added successfully',
      text: 'the upload will be performed upon saving',
    },
    error: 'Error',
    snackbar: {
      success: { title: 'File Upload', text: 'Uploaded with success' },
      error: { title: 'File Upload', text: 'Upload error' },
    },
    deleteModal: {
      title: 'Delete file',
      text: 'This file will be deleted permanently and cant be recovered',
      confirm: 'Confirm',
      cancel: 'Cancel',
      snackbar: {
        success: { title: 'File Deleted', text: 'File deleted successfully' },
        error: { title: 'File no Deleted', text: 'Error on delete' },
      },
    },
  },
  list: { chart: 'Chart', noData: 'No data found for this section' },
  inputs: {
    required_field: 'This field is required',
    invalid_date: 'Invalid date',
  },
  statusSelectWithButton: {
    label: {
      save: 'Save',
      saved: 'Saved',
      selectPrefix: 'Stage:',
      cancel: 'Cancel',
      saveDescription: 'Save description',
    },
  },
  noData: 'No data',
  caseListItem: {
    options: {
      dimensions: {
        auxiliary_system: 'Auxiliary System',
        process_condition: 'Process Condition',
        dynamic_condition: 'Dynamic Condition',
        oil_analysis: 'Oil Analysis',
      },
    },
  },
  external_reference: {
    type: {
      '': 'Select ref.',
      SAP: 'SAP Note',
      OTHER: 'Other',
    },
    type_label: 'External reference',
    code_label: 'External reference code',
    placeholders: {
      selectReference: 'Select ref.',
      code: 'Enter code',
    },
  },
  feature_tooltip: {
    button_text: 'Got it',
  },
  status_indicators: {
    models_alarming: 'Models alarming',
    cases_opened: 'Cases open',
  },
  custom_toolbar: {
    headings: {
      1: 'Heading 1',
      2: 'Heading 2',
      3: 'Heading 3',
      4: 'Heading 4',
      5: 'Heading 5',
      6: 'Heading 6',
      normal: 'Normal',
    },
  },
};
